
























import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import VulnerabilityType from "@/types/VulnerabilityType";
import PlatformIcon from "@/components/PlatformIcon.vue";

@Component({
  components: {
    PlatformIcon
  }
})
export default class SidebarVulnerability extends Vue {
  @Prop() private vulnerability!: VulnerabilityType;
  @Prop() private isActive!: boolean;
  @Prop() private hasUpdates!: boolean;
  @Prop() private targetLanguage!: string;

  private isDirty = false;

  @Watch("$store.state.modifiedVulnerabilitiesCounter")
  private watchModifiedVulnerabilities() {
    if (parseInt(this.$route.params.id) === this.vulnerability.id) {
      this.getIsDirty();
    }
  }

  getIsDirty() {
    if (!this.vulnerability) {
      this.isDirty = false;
    }
    this.isDirty = !!this.$store.getters.getModifiedVulnerability(
      this.vulnerability.id,
      this.targetLanguage
    );
  }

  paddedNumber(n: number, m: 3) {
    if (n < 10) {
      return `${"0".repeat(m - 1)}${n}`;
    }
    if (n < 100) {
      return `${"0".repeat(m - 2)}${n}`;
    }
    return `${n}`;
  }

  mounted() {
    this.getIsDirty();
  }
}
